import React from "react";
import { Formik } from "formik";
import { Button, TextField } from "@mui/material";
import { useDispatch } from "react-redux";

import {
  useAddNoteCommentMutation,
  useUpdateNoteCommentMutation,
} from "app/store/transmission/api/transmissionNotesApi";
import { noteCommentValidationSchema } from "schemas/noteCommentValidationSchema";
import { setEvokeReportNotes } from "app/store/transmission/slice/transmissionSlice";

import SubmitButton from "components/Button/SubmitButton";
import { showErrorToast, showSuccessToast } from "utils/toast";

const NoteCommentForm = ({ reportId, contentId, comment, handleCancel }) => {
  const dispatch = useDispatch();

  const [addNoteComment] = useAddNoteCommentMutation();
  const [updateNoteComment] = useUpdateNoteCommentMutation();

  const handleComment = async (values) => {
    const payload = {
      reportId,
      contentId,
      comment: values?.comment,
    };

    try {
      let response;
      if (comment?._id) {
        response = await updateNoteComment({
          ...payload,
          commentId: comment?._id,
        }).unwrap();
      } else {
        response = await addNoteComment(payload).unwrap();
      }

      if (!response?.error) {
        dispatch(setEvokeReportNotes(response?.data?.evoke_notes));
        showSuccessToast(response?.message);
        handleCancel();
      }
    } catch (error) {
      showErrorToast(error);
    }
  };

  return (
    <Formik
      initialValues={{
        comment: comment?.text || "",
      }}
      validationSchema={noteCommentValidationSchema}
      onSubmit={(values) => handleComment(values)}
      enableReinitialize
    >
      {({
        values,
        errors,
        touched,
        handleSubmit,
        isSubmitting,
        isValid,
        setFieldValue,
      }) => {
        const initialComment = comment?.text || "";
        const isCommentEmpty = !values.comment || values.comment.trim() === "";
        const isEditingWithoutChanges =
          comment?._id && values.comment === initialComment;

        return (
          <div
            style={{
              padding: "8px",
              marginLeft: "8px",
              backgroundColor: "#F5F5F5",
            }}
          >
            <TextField
              minRows={2}
              multiline
              fullWidth
              style={{ background: "#fff" }}
              placeholder="Write notes here"
              value={values?.comment}
              onChange={(event) => {
                setFieldValue("comment", event.target.value);
              }}
              onBlur={() => {
                setFieldValue("comment", values.comment?.trim() || "");
              }}
              error={touched.comment && !!errors.comment}
              helperText={touched.comment && errors.comment}
              inputProps={{ maxLength: 100 }}
            />

            <div className="d-flex flex-end align-items-center mt-2 g-1">
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleCancel}
              >
                Cancel
              </Button>
              <SubmitButton
                buttonText="Save"
                handleClick={handleSubmit}
                disabled={
                  isSubmitting ||
                  !isValid ||
                  isCommentEmpty ||
                  isEditingWithoutChanges
                }
              />
            </div>
          </div>
        );
      }}
    </Formik>
  );
};

export default NoteCommentForm;
